@defer (when externalPropertyViewModel) {
  <div class="main-container" #labelledContainer
    [class.full-width]="isFullWidth">
    <div class="label-container" [class.full-width]="isFullWidth">
      <nts-label-box
        (click)="isLabelZoomEnabled ? openZoom() : null"
        [class.zoom-label]="isLabelZoomEnabled"
        [title]="externalPropertyViewModel.metadataDescription"
        [label]="externalPropertyViewModel.metadataShortDescription"></nts-label-box>
    </div>

    <div class="edit-container">
      <nts-ext-new-autocomplete-text-box
        #textBox
        [isDisabled]="isDisabled"
        [appendTo]="appendTo"
        [decodeProperties]="decodeProperties"
        [searchProperties]="searchProperties"
        [fieldSeparator]="fieldSeparator"
        (keyDown)="onKeyDown($event)"
        (viewReady)="onTextBoxViewReady()"
        [externalPropertyViewModel]="externalPropertyViewModel"
        [tabIndex]="tabIndex"
        [updateOnBlur]="true"
        [enableOutsideClickListener]="enableOutsideClickListener"
        [showCodeInDescription]="showCodeInDescription">
      </nts-ext-new-autocomplete-text-box>
    </div>
  </div>
} @placeholder {
  @if (!loadingError) {
    <div class="loading-container">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <div class="loading-text">Caricamento componente...</div>
    </div>
  }
}

@if (loadingError) {
  <div class="error-container">
    <div class="error-message">
      <p>{{ loadingError?.description || 'Impossibile caricare il componente.' }}</p>
    </div>
  </div>
}